import { skipToken, useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';
import type { GetTransferOrderResponse } from '@erp/rpc';

export function useTransferOrder(id: string | undefined, enabled = true) {
  const query = useQuery({
    ...orpc.inventoryManagement.transferOrders.get.queryOptions({
      input: id ? { id } : skipToken,
    }),
    enabled: Boolean(id) && enabled,
  });

  return {
    ...query,
    transferOrder: query.data?.transferOrder ?? null,
    lineItems: query.data?.lineItems ?? [],
    charges: query.data?.charges ?? [],
  } satisfies typeof query & {
    data?: GetTransferOrderResponse;
    transferOrder: GetTransferOrderResponse['transferOrder'] | null;
    lineItems: GetTransferOrderResponse['lineItems'];
    charges: GetTransferOrderResponse['charges'];
  };
}
